module.exports = "/_next/static/images/Duke-edb382908b39b25d0c6d352156984e54.png";